import { render, staticRenderFns } from "./RequestedDids.vue?vue&type=template&id=717b8584&scoped=true&"
import script from "./RequestedDids.vue?vue&type=script&lang=js&"
export * from "./RequestedDids.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717b8584",
  null
  
)

export default component.exports